import React from "react";
import { getCookie, setCookie } from "cookies-next";
import { useStoreContext } from "../context";
import { Actions } from "../context/reducer";
import { Store } from "../decleration";

const useTheme = (): { theme: Store["theme"]; toggleTheme: () => void } => {
  const {
    dispatch,
    state: { theme },
  } = useStoreContext();

  const toggleTheme = () => {
    if (theme === "light") {
      setCookie("theme", "dark");
      dispatch({ type: Actions.TOGGLETHEME, payload: "dark" });
      document.documentElement.classList.add("dark");
    } else {
      setCookie("theme", "light");
      dispatch({ type: Actions.TOGGLETHEME, payload: "light" });
      document.documentElement.classList.remove("dark");
    }
  };

  React.useEffect(() => {
    const savedTheme = getCookie("theme");

    if (!savedTheme) {
      const systemPrefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)",
      ).matches;
      const defaultTheme = systemPrefersDark ? "dark" : "light";
      dispatch({ type: Actions.TOGGLETHEME, payload: defaultTheme });

      if (defaultTheme === "dark") {
        document.documentElement.classList.add("dark");
      }
    } else {
      dispatch({ type: Actions.TOGGLETHEME, payload: savedTheme });
      if (savedTheme === "dark") {
        document.documentElement.classList.add("dark");
      }
    }

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e: MediaQueryListEvent) => {
      if (!getCookie("theme")) {
        const newTheme = e.matches ? "dark" : "light";
        dispatch({ type: Actions.TOGGLETHEME, payload: newTheme });
        if (newTheme === "dark") {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      }
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return { toggleTheme, theme };
};

export default useTheme;
